const TRADE_TYPE_INDICATOR_WIDTH = '18px';
const TRADE_TYPE_INDICATOR_HEIGHT = '18px';

export { TRADE_TYPE_INDICATOR_HEIGHT, TRADE_TYPE_INDICATOR_WIDTH };
